import axios from 'axios'

export default {
    getImportLog(payload) {
        return axios.post('/api/logs', payload)
    }
}
